<app-svg-definitions (loaded)="defsLoaded=true"></app-svg-definitions>



<div class="container">
    <div class="row">
        <div class="col">
            @if(portfolioNumber==null){
                loading...
            }
            @else if(portfolioNumber=="coming soon"){
                <h1>Coming Soon</h1>
            }
              </div>
    </div>
</div>

@if(portfolioNumber!=null && portfolioNumber != "coming soon" && investment!=null){
    <div class="subNav">
        <div class="container">
            <div class="row">
                <div class="col">
<!-- {{equity}}<br>
    {{investment}} -->
                </div>
            </div>
        </div>
    </div>


    <app-portfolio-banner-with-nav [postRoute]="''" [preRoute]="''" [pre]="pre" [post]="post" (secretClick)="pballClick()" ></app-portfolio-banner-with-nav>
    

    <div class="container">
         <div class="row" *ngIf="showAllocation && investmentSymbol!=null">
            <div class="col-12">               
                <app-portfolio-allocation [investmentSymbol]="investmentSymbol"></app-portfolio-allocation>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 mb-5">
                    <!-- <p>portfolio-mixed works!</p>
                    <div>{{portfolio}}</div>
                    <div class="code-block">  
                    <code>
{{investment|json}}
                   </code>
                   </div> -->
                    <ng-container *ngFor="let chart of charts;let idx = index;">
                        <!-- {{chart|json}} -->
                        <ng-container *ngIf="chart.id!=null">
                            <div id="{{(idx+1)}}" class="fig-num pt-3"><em class="fig">Figure {{(idx+1)}}</em>
                                <a routerLink="./" fragment="{{(idx+1)}}" class="permalink">(permalink)</a>
                            </div>
                            <app-chart-embed [id]="chart.id" [query]="`?param1=${investmentSymbol}|${pre}|${post}|S${s}B${b}`"></app-chart-embed>
                        </ng-container>
                    </ng-container>
                    
            </div>
              <div class="col-lg-4 pt-3">
                
                <div class="sticky-top">
                    <app-portfolio-side-navigation [charts]="charts"></app-portfolio-side-navigation>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                  <div class="clearfix mt-5 mb-5"></div>
   
      @if (exclusions) {
        <div [innerHtml]="exclusions[0].html | safe: 'html'"></div>
      }

      <p>For more information see Socially Responsible Investing at <a href="https://us.dimensional.com/funds" target="_blank">dimensional.com</a></p>
   
            </div>
        </div>
    </div>
}

     